import { useEffect } from 'react';

import { cleanQueryParams } from '@editor/utils/url';
import {
  PROMO_CODE,
  urlParams,
  getCaseInsensitiveParam,
} from '@editor/utils/window';

import { setPromoCodeCookie } from '../../utils';

/**
 * This hook reads the promo code from the URL and sets it in a cookie.
 */
const usePromoCodeCookie = (): void => {
  useEffect(() => {
    // NOTE: A user may inadvertently change the case of the url params when typing in the url bar so we use a case insensitive search
    const promoCode = getCaseInsensitiveParam(PROMO_CODE, urlParams);
    if (promoCode) {
      setPromoCodeCookie(promoCode);
      cleanQueryParams(urlParams, [PROMO_CODE]);
    }
  }, []);
};

export default usePromoCodeCookie;
